import React from 'react';
import {useNavigate} from 'react-router';
import {Stack, Typography, useTheme} from '@mui/material';
import {imagekitStaticURL} from '../util/util.js';

const BlockGalleryItem = props=>{
    let {title, link, image} = props;
    let navigate = useNavigate();
    let theme = useTheme();
    return <Stack position="relative" width="200px" height="200px"
      justifyContent="center" alignItems="center"
      padding={2} onClick={()=>navigate(link)}
      sx={{
          boxShadow: theme.shadows[2],
          border: `8px double ${theme.palette.primary.contrastText}`,
          borderRadius: '12px',
          backgroundImage: `url(${imagekitStaticURL(image)})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          color: theme.palette.primary.contrastText,
          cursor: 'pointer',
          ':hover': {
              transform: 'translateY(-4px)',
              boxShadow: theme.shadows[10],
          },
          transition: 'transform 0.1s ease-in, box-shadow 0.1s ease-in',
      }}>
      <Typography variant="h5" align="center" sx={{zIndex: 1, textShadow: '0 0 1em #ef4fff, 0 0 4px black, 0 0 4px black, 0 0 4px black'}}>
        {title}
      </Typography>
    </Stack>;
};

const BlockGallery = props=>{
    let {items} = props;
    return <Stack justifyContent="center" alignItems="center">
      <Stack direction="row" gap={4} flexWrap="wrap" justifyContent="center" alignItems="center">
        {items.map((item, i)=><BlockGalleryItem key={i} {...item}/>)}
      </Stack>
    </Stack>;
};

export default BlockGallery;
